<div role="group"
     class="phone-input-container"
     [attr.aria-labelledby]="_formField?.getLabelId()">
  <input [formControl]="displayValueControl"
         type="tel"
         matInput
         [placeholder]="placeholder"
         (blur)="onInputBlurred()"
         aria-label="phoneNumber"
         #phoneInput>
</div>
